module.exports = global["enquire"] = require("-!/home/circleci/repo/node_modules/babel-loader/lib/index.js??ref--5!./enquire.js");